import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Switch as MuiSwitch, Box } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import EasyTechIcons, { IconTypes } from 'components/Icons/EasyTechIcons';
import { InfoTitle } from 'components/shared';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&.MuiFormControlLabel-root': {
        marginRight: '0',
      }
    },
    switch: {
      '& .Mui-checked': {
        color: 'var(--grayLv3)'
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        background: 'var(--grayLv4)'
      },
    },
    label: {
      '& .MuiFormControlLabel-label': {
        color: 'var(--grayLv3)',
        fontSize: '1.2rem',
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.4rem",
        },
      }
    },
    legend: {
      fontSize: '1.2rem',
      color: 'var(--grayLv4)',
      '&.MuiFormLabel-root.Mui-focused': {
        color: 'var(--grayLv4)'
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: "1.4rem",
      },
    }
  }));

interface ISwitchProps {
  label: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  checked?: boolean,
  name: string,
  id?: string,
  icon?: IconTypes,
  align?: 'right' | 'left',
  title: string
}

export const Switch = ({ label, onChange, checked = false, name, id, icon, align = 'right', title }: ISwitchProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <InfoTitle>
        {title}
        {icon && (
          <EasyTechIcons name={icon} />
        )}
      </InfoTitle>

      <Box>
        {align === 'left' && (
          <FormControlLabel
            style={{ marginRight: '8px' }}
            className={classes.root}
            control={<MuiSwitch id={id} className={classes.switch} checked={checked} onChange={onChange} name={name} />}
            label=""
          />
        )}

        <div style={{ display: 'inline-flex', alignItems: 'center', color: 'var(--grayLv3)' }}>
          <span>{label}</span>
        </div>

        {align === 'right' && (
          <FormControlLabel
            style={{ marginLeft: '8px' }}
            className={classes.root}
            control={<MuiSwitch id={id} className={classes.switch} checked={checked} onChange={onChange} name={name} />}
            label=""
          />
        )}
        <strong style={{ color: 'var(--grayLv3)' }}>{checked ? 'SIM' : 'NÃO'}</strong>
      </Box>
    </Box>
  );
}